import EditorJS from '@editorjs/editorjs';
import { InstructionCSSClasses, InstructionEvent, InstructionAttribute } from '../types';
import { emitInstructionEventByEditor } from '../utils';
import { detectIOS } from '../../../../utility/helpers';

export const addEventListenerNoteActions = async (
  params: {
    instanceEditor: EditorJS;
    refEditor: HTMLDivElement;
  },
) => {
  const { instanceEditor, refEditor } = params;

  const actionHandler = (event: MouseEvent | TouchEvent) => {
    const mappedTarget = event.target as HTMLSpanElement;
    const { parentElement } = mappedTarget;
    if (parentElement) {
      const instructionId = parentElement.getAttribute(InstructionAttribute.instructionId);
      if (instructionId) {
        emitInstructionEventByEditor(
          instanceEditor,
          InstructionEvent.OPEN_NOTE_INSTRUCTION_MODAL,
          {
            instructionId,
            isInline: true,
          },
        );
      }
    }
  };

  instanceEditor.isReady.then(() => {
    const actions = refEditor.querySelectorAll<HTMLSpanElement>(
      `.${InstructionCSSClasses.NOTE_INSTRUCTION_ACTION}`,
    );
    actions.forEach((item) => {
      if (detectIOS()) {
        // eslint-disable-next-line
        item.onmouseenter = actionHandler;
      }
      // eslint-disable-next-line
      item.onclick = actionHandler;
    });
  });
};
